<!-- Screen reader announcement for tab changes -->
<div
  aria-live="polite"
  aria-atomic="true"
  class="sr-only"
>
  {{ tabAnnouncement }}
</div>

<!-- Tab list -->
<div
  role="tablist"
  [class]="tabListClasses()"
  [attr.aria-label]="ariaLabel()"
>
  @for (tab of tabs(); track tab.id; let i = $index) {
    <button
      type="button"
      role="tab"
      [id]="'tab-' + tab.id"
      [attr.disabled]="tab.disabled ? true : null"
      [attr.aria-selected]="isActiveTab(tab.id)"
      [attr.aria-controls]="'panel-' + tab.id"
      [attr.aria-disabled]="tab.disabled"
      [attr.tabindex]="isActiveTab(tab.id) ? 0 : -1"
      [class]="getTabClasses(tab)"
      (click)="selectTab(tab)"
      (keydown)="onKeyDown($event, i)"
    >
      <!-- Icon (if provided)
           GAP-FE-PRIME-P6 r2 (Codex) · the legacy @switch covered
           only 5 hardcoded names + a list fallback; any other
           name (check-circle/code/shield/history/etc.) rendered
           the generic "list" glyph. Replaced with <ui-icon> which
           resolves any registered Heroicons name. -->
      @if (tab.icon) {
        <ui-icon [name]="tab.icon" size="sm" aria-hidden="true"></ui-icon>
      }

      <!-- Label -->
      <span>{{ tab.label }}</span>

      <!-- Badge (if provided) -->
      @if (tab.badge !== undefined) {
        <span [class]="badgeClasses()">
          {{ tab.badge }}
        </span>
      }
    </button>
  }
</div>

<!-- Tab panels -->
<div class="m-4">
  <ng-content></ng-content>
</div>
